import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MENU_SECTION } from '@conversion/constants';
import Groceries from '@components/ProductCard/Groceries';

import WithBeforePrice from '@conversion/containers/ShelvesLayout/HOCs/WithBeforePrice';
import { tagManager } from './HOCs/utils';

function ShelvesItem({
  product,
  onClick,
  measurementItems,
  width,
  groceriesPrice,
  beforePriceTags,
  shopAcceptsPreOrder,
  shopIsOpen,
}) {
  const onClickHandler = useCallback(
    clickLocation => {
      onClick(product, clickLocation, MENU_SECTION.SECTION);
    },
    [onClick, product],
  );

  const {
    id,
    name,
    image,
    campaignTags,
    pricePerMeasurementUnit,
    measurementUnit,
    priceWithoutTax,
  } = product;
  const tags = tagManager({ beforePriceTags, id, campaignTags });

  const measurementUnitPerProduct = {
    pricePerMeasurementUnit,
    measurementUnitId: measurementUnit?.id,
    measurementItems,
  };

  return (
    <Groceries
      width={width}
      name={name}
      image={image}
      onClick={onClickHandler}
      tags={tags}
      elementId="infocard"
      price={groceriesPrice}
      priceWithoutTax={priceWithoutTax}
      measurementUnit={measurementUnitPerProduct}
      product={product}
      shopAcceptsPreOrder={shopAcceptsPreOrder}
      shopIsOpen={shopIsOpen}
    ></Groceries>
  );
}

ShelvesItem.propTypes = {
  product: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  measurementItems: PropTypes.array,
  width: PropTypes.string,
  groceriesPrice: PropTypes.node,
  beforePriceTags: PropTypes.array,
  shopAcceptsPreOrder: PropTypes.bool,
  shopIsOpen: PropTypes.bool,
};

const withBeforePrice = T => WithBeforePrice(T);

export default withBeforePrice(ShelvesItem);
